import { tv } from 'tailwind-variants';
import { Icon } from '@frontendmentorio/design-system-v2';

const styles = tv({
  slots: {
    wrapper: [
      'bg-gray-100',
      'flex',
      'font-secondary',
      'gap-3',
      'h-min',
      'items-center',
      'justify-center',
      'rounded-full',
      'px-4',
      'py-1',
      'w-min',
    ],
    icon: ['text-neutral-500', 'transition-transform'],
  },
  variants: {
    isOpen: {
      true: {
        wrapper: ['bg-neutral-200', 'text-neutral-900'],
        icon: ['text-neutral-700'],
      },
    },
  },
});

export default function ReplyButton({
  className,
  disabled,
  comment,
  isOpen,
  onClick: handleClick,
}) {
  const { wrapper, icon } = styles({ isOpen });

  return (
    <button
      aria-label={isOpen ? 'Hide replies' : 'Show replies'}
      className={wrapper({ class: className })}
      disabled={disabled}
      onClick={handleClick}
    >
      <Icon
        className={icon()}
        name="comment"
        style={isOpen ? 'solid' : 'regular'}
      />
      <span>{comment.replies?.length || 0}</span>
    </button>
  );
}
